import { render, staticRenderFns } from "./NewBudgetsHelp.vue?vue&type=template&id=5235a3f9&scoped=true"
import script from "./NewBudgetsHelp.vue?vue&type=script&lang=js"
export * from "./NewBudgetsHelp.vue?vue&type=script&lang=js"
import style0 from "./NewBudgetsHelp.vue?vue&type=style&index=0&id=5235a3f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5235a3f9",
  null
  
)

export default component.exports